var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vca-card',{staticClass:"payment-footer"},[_c('p',[_vm._v(" "+_vm._s(_vm.$t('information.label'))+" "),_c('ul',[_c('li',[_vm._v(_vm._s(_vm.$t('information.info_1')))]),_c('li',[_vm._v(_vm._s(_vm.$t('information.info_2')))]),_c('li',[_vm._v(_vm._s(_vm.$t('information.info_3')))]),_c('li',[_vm._v(_vm._s(_vm.$t('information.info_4')))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }